import React, { useEffect, useState } from "react";
import logo from "./logo.png";
import "./App.css";

function App() {
  const [unsupported, setUnsupported] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href =
        "https://apps.apple.com/gb/app/japaflex/id6741498301"; // Replace with your actual App Store URL
    }
    // Android detection
    else if (/android/i.test(userAgent)) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.japaflex.mobile"; // Replace with your actual Play Store URL
    }
    // Not supported
    else {
      setUnsupported(true);
    }
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="Japaflex" />
        {unsupported ? (
          <p>This platform is not supported.</p>
        ) : (
          <p>Redirecting, Please wait...</p>
        )}
      </header>
    </div>
  );
}

export default App;
